// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricG":"G_SaveElectricG__lKvDr"};